<template>
  <Flex justify="between">
    <Flex
      direction="column"
      :gap="1.5"
    >
      <BaseText size="l">
        {{ $t('subscription.cancelation_flow.form_label.main_reason') }}
      </BaseText>
      <BaseRadio
        v-model="selectedReason"
        :options="[
          {
            label: $t('subscription.cancelation_flow.options.dont_need_salonized', brandName()),
            value: 'dont_need_salonized',
          },
          {
            label: $t('subscription.cancelation_flow.options.doesnt_work_for_me', brandName()),
            value: 'doesnt_work_for_me',
          },
          {
            label: $t(
              'subscription.cancelation_flow.options.i_have_life_business_change',
            ),
            value: 'i_have_life_business_change',
          },
          {
            label: $t('subscription.cancelation_flow.options.its_too_expensive', brandName()),
            value: 'its_too_expensive',
          },
        ]"
        required
        v-test="'cancel-flow-cancel-main-reason'"
      />
    </Flex>
    <img
      v-if="$screen !== 's'"
      src="/img/cancel-subscription/person-asking-why.svg"
      :class="$style.image"
    >
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import { brandName } from '@/helpers/brand-name';
import type { CancelReasons } from './types';

const emit = defineEmits(['update:modelValue']);

const props = defineProps<{
  modelValue: CancelReasons;
}>();

const selectedReason = computed({
  get: () => props.modelValue.main_reason,
  set: (value) => {
    const cleared = Object.fromEntries(
      Object.keys(props.modelValue).map((k) => [k, '']),
    );
    emit('update:modelValue', { ...cleared, main_reason: value });
  },
});
</script>

<style
  lang="scss"
  module
>
.image {
  height: 170px;
  width: auto;
}
</style>
